import { useContext } from 'react';
import ContactMethodsMenuContext, {
  ContactMethodsMenuContextType,
} from './ContactMethodsMenuContext';

const useContactMethodsMenuContext = (): ContactMethodsMenuContextType => {
  const context = useContext(ContactMethodsMenuContext);
  if (!context) {
    return {
      setIsContactsMenuOpen: undefined,
      setShouldCloseOnOutsideClick: undefined,
    };
  }
  return context;
};

export default useContactMethodsMenuContext;
